import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentYield: 1,
  loading: false,
  error: false,
};

export const yieldSlice = createSlice({
  name: "yield",
  initialState,
  reducers: {
    yieldStart: (state) => {
      state.loading = true;
    },
    yieldSuccess: (state, action) => {
      state.loading = false;
      state.currentYield = action.payload;
    },
    yieldFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

export const { yieldStart, yieldFailure, yieldSuccess } = yieldSlice.actions;
export default yieldSlice.reducer;
